import { useContext } from "react";
import { BetslipContext } from '../data/betslip/BetslipConf';
import { ASIAN_HANDICAP } from '../data/constants';
import { getBetDescription, getConfiguration, parseHandicap } from '../data/utils';

function getBetdata(odd) {
    const conf = getConfiguration();

    if (odd.value == null) {
        return;
    }

    const betData = odd.betData;
    const betId = betData.cs != null ? betData.cs : betData.id;

    let hcp = betData.handicap;
    if (conf.nas && ASIAN_HANDICAP.includes(betData.id) && odd.id === 2) {
        hcp *= -1;
    }
    let betDesc = betData.desc;
    let oddDesc = odd.desc;
    if (betData.hideHandicap === true) {
        betDesc = betData.aggDesc;
        oddDesc = `${betData.desc} ${odd.desc}`;
    } 
    else  {
        betDesc = getBetDescription(betData, false, odd.matchData.sportRef);
    }
/*else if (betData.handicap !== 0) {
        let draws = null;
        if (betData.tipoHandicap === 7) {
            draws = betData.eqs;
        }
        betDesc = parseHandicap(betData.desc, hcp, betData.tipoHandicap, draws, betData.dia);
    }*/
    const timestamp = odd.matchData.timestampDB? odd.matchData.timestampDB : odd.matchData.timestamp;
    
    return {
        pal: odd.matchData.pal,
        avv: odd.matchData.avv,
        alias: odd.matchData.alias,
        matchDesc: odd.matchData.desc,
        isLive: betData.isLive,
        betId: betId,
        handicap: betData.handicap,
        betDesc: betDesc,
        id: odd.id,
        desc: oddDesc,
        value: odd.rawValue,
        legabile: betData.legabile,
        sportDesc: odd.matchData.sportDesc,
        tournamentDesc: odd.matchData.tournamentDesc,
        timestamp: timestamp,
        sportRef: odd.matchData.sportRef,
        tournamentRef: odd.matchData.tournamentRef
    };
}

export default function useBetslip(props) {
    const betslipContext = useContext(BetslipContext);

    function addBet(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const betData = getBetdata(props);
        if (betData == null) {
            return;
        }
        
        betslipContext.toggleSelectionBetslip(betData.pal,
                                              betData.avv,
                                              betData.alias,
                                              betData.matchDesc,
                                              betData.isLive,
                                              betData.betId,
                                              betData.handicap,
                                              betData.betDesc,
                                              betData.id,
                                              betData.desc,
                                              betData.value,
                                              betData.legabile,
                                              betData.sportDesc,
                                              betData.tournamentDesc,
                                              betData.timestamp,
                                              betData.sportRef,
                                              betData.tournamentRef,
                                              betData.ming,
                                              betData.maxg,
                                              props.matchData);
    }

    const selected = betslipContext.isDrawSelected(props.matchData.pal, props.matchData.avv, props.betData.id, props.betData.handicap, props.id);

    return [addBet, selected];
}
